// Google Analytics utility module for PlantCare
// Usage: import { initGA, trackPageView, trackEvent } from './ga'

let isGAEnabled = false;
let measurementId = null;

export function initGA() {
  measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;
  isGAEnabled = import.meta.env.VITE_GA_ENABLED === 'true' && !!measurementId;

  if (!isGAEnabled) return;

  // Inject GA script
  if (!window.gtag) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', measurementId);
  }
}

export function trackPageView(path) {
  if (!isGAEnabled || !window.gtag) return;
  window.gtag('config', measurementId, { page_path: path || window.location.pathname });
}

export function trackEvent({ action, category, label, value }) {
  if (!isGAEnabled || !window.gtag) return;
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  });
} 